import { useTranslation } from 'react-i18next'

import DbList from 'components/DbManagingList'
import Spacer from 'components/Spacer'
import { maskValue } from 'utils/helpers'

export default function DbSection({ info }) {
  const { t } = useTranslation()

  return (
    <div>
      <p>{t('summary.managing_purchasing_info')}</p>
      <Spacer height={15} />
      <DbList />
      <Spacer height={20} />
      <p className="footer">
        {t('home.database.modal.footer', {
          databases: info.databases,
          hours: info.hours,
        })}
      </p>
      <Spacer height={10} />
      <p className="footer_price">
        {t('home.database.modal.footer_price', {
          total: maskValue(info.totalValue),
        })}
      </p>
    </div>
  )
}
